import React, { useState } from "react";
import CompanyBasedBillableListing from "@/modules/reports/billables/status/company-listing";
import { StatsSection } from "@/modules/reports/billables/status/components/stats-section";
import CancelledFilters from "@/modules/reports/billables/status/cancelled/filters";
import { statusWiseCancelledDateFilters } from "@/modules/reports/billables/status/constant";
import CommonTable from "components/list/table";
import { getChildData, getChildColumns, getBillableFiltersFromCompanyFilters } from "@/modules/reports/billables/status/child-table-config";

const CancelledBillables = () => {
  const [filters, setFilters] = useState({
    contacts: {
      projects: {
        jobs: {
          billables: {
            ...statusWiseCancelledDateFilters,
            status: {
              _eq: "cancelled"
            }
          }
        }
      }
    }
  });

  return (
    <CompanyBasedBillableListing
      title="Cancelled Billables"
      status="cancelled"
      onFiltersChange={setFilters}
      filters={CancelledFilters}
      sortOrder="asc"
      enableAccordion={true}
      renderExpandedRow={(row) => (
        <div className="border rounded-md overflow-hidden bg-background">
          <CommonTable
            data={getChildData(row, "cancelled")}
            columns={getChildColumns("cancelled")}
            showHeader={true}
          />
        </div>
      )}
      renderContent={() => (
        <StatsSection status="cancelled" filters={getBillableFiltersFromCompanyFilters(filters)} />
      )}
      statusWiseFilters={{
        contacts: {
          projects: {
            jobs: {
              billables: {
                ...statusWiseCancelledDateFilters,
                status: {
                  _eq: "cancelled"
                }
              }
            }
          }
        },
      }}
      statusWiseDateFilters={statusWiseCancelledDateFilters}
    />
  );
};

export default CancelledBillables;
